import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HtmlIcon(props: IconProps) {
    return <Icon {...props} iconKey={"html"}/>
}
